<template>
  <UserLayout>
    <section class="">
      <div class="h-full">
        <section class="grid grid-cols-12 border-b border-gray-280">
          <div class="md:col-span-8 col-span-12">
            <div class="py-4 px-2">
              <h3 class="text-gray-dark font-bold text-lg">Class Pack</h3>
              <SessionDetailsThumbnail
                :src="
                  baseUrlSrc(course.details && course.details.thumbnail_url)
                "
                :supportingImages="userCourseDetail.supporting_images"
                :sessions="userCourseDetail.sessions"
                :course="course"
                :course_groups="batches.course_groups"
              />
            </div>
          </div>
          <div class="col-span-4" id="overview">
            <section
              class="border-gray-280 shadow-lg"
              style="height: calc(100% - 141px)"
            >
              <section class="md:mt-12 px-4">
                <section class="py-4">
                  <div class="flex justify-between">
                    <div>
                      <p
                        class="text-gray-dark font-semibold text-lg capitalize"
                      >
                        {{
                          handleStr(
                            course && course.details && course.details.title,
                            50
                          )
                        }}
                      </p>
                      <div class="flex items-center -mt-1">
                        <Rating :data="course.average_rating" />
                        <p class="text-sm ml-1">
                          {{ course.average_rating }}
                          <span class="text-xs text-gray-dark"
                            >({{ course.total_count }})</span
                          >
                        </p>
                      </div>
                    </div>
                    <div class="relative" v-click-outside="toggleDotsVertical">
                      <button
                        type="button"
                        @click="isDotsVerticalOpen = !isDotsVerticalOpen"
                      >
                        <DotsVertical />
                      </button>
                      <div
                        class="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lgx z-10"
                        v-show="isDotsVerticalOpen"
                      >
                        <div
                          class="py-1 relative rounded-md bg-white shadow-xs z-10 h-10"
                          role="menu"
                          aria-orientation="vertical"
                          aria-labelledby="user-menu"
                        >
                          <button
                            type="button"
                            class="block px-4 py-2 text-sm leading-5 text-gray-700 focus:outline-none focus:bg-gray-100 transition duration-150 ease-in-out w-full text-left rounded"
                            role="menuitem"
                            @click="handleUserReportingModal(true)"
                          >
                            Report
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <p class="text-gray-350 text-sm mt-2">
                    {{
                      course &&
                      course.details &&
                      handleStr(course.details.description, 150)
                    }}
                  </p>
                  <p
                    class="font-bold text-2xl"
                    v-if="course && course.details && course.details.cost !== 0"
                  >
                    $ {{ course && course.details && course.details.cost }}
                  </p>
                  <p class="font-bold text-xl" v-else>Free Class</p>

                  <section>
                    <!-- course joined for desktop-->
                    <div class="hidden md:grid" v-show="isCoursesOpen">
                      <div
                        class="py-3 uppercase text-xs font-semibold"
                        v-if="batches.is_slots_subscribed"
                      >
                        Booked Class Pack
                      </div>
                      <div
                        class="rounded-lg bg-gray-50"
                        v-if="batches.is_slots_subscribed"
                      >
                        <div class="">
                          <CourseGroupsJoined
                            v-on:sessions-group="handleJoinModal"
                            v-on:hide-slot="handleHideSlot"
                            v-on:show-slot="handleHideSlot"
                            :data="batches"
                          />
                        </div>
                      </div>
                    </div>
                    <!-- slots-->

                    <div
                      v-if="
                        batches &&
                        batches.course_groups &&
                        batches.course_groups.available &&
                        batches.course_groups.available.data &&
                        batches.course_groups.available.data.length > 1 &&
                        showPopper
                      "
                      class="fixed z-10 inset-0 overflow-y-auto inline md:hidden"
                    >
                      <SelectSlotFooterModal
                        :data="batches"
                        :nextPageUrl="
                          batches.course_groups.available.next_page_url
                        "
                        type="courseData"
                        :handleShowMoreAvail="handleShowMoreAvail"
                        :handleFooterPopper="handleFooterPopper"
                        :handleJoinModal="handleJoinModal"
                        :selectedCourseSlotId="selectedCourseSlotId"
                      />
                    </div>
                  </section>
                  <section class="mt-6">
                    <div v-if="isCourseJoinModalOpen" class="py-2">
                      <button
                        class="back-button"
                        type="button"
                        @click="toggleJoinInfoHandler"
                      >
                        <!-- arrow-left icon -->
                        <svg
                          class="standard-back-button"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M18.125 11.1435H7.7475L10.9238 7.40666C11.0723 7.23163 11.1437 7.00599 11.1224 6.77935C11.1011 6.55272 10.9887 6.34368 10.81 6.1982C10.6313 6.05272 10.4009 5.98273 10.1696 6.00363C9.93819 6.02452 9.72477 6.13459 9.57625 6.30962L5.20125 11.452C5.17182 11.4929 5.14549 11.5359 5.1225 11.5806C5.1225 11.6234 5.1225 11.6491 5.06125 11.692C5.02159 11.7903 5.00082 11.8949 5 12.0005C5.00082 12.1062 5.02159 12.2108 5.06125 12.3091C5.06125 12.3519 5.06125 12.3776 5.1225 12.4205C5.14549 12.4652 5.17182 12.5082 5.20125 12.5491L9.57625 17.6915C9.65852 17.7882 9.76154 17.866 9.87799 17.9193C9.99444 17.9727 10.1215 18.0002 10.25 18C10.4544 18.0004 10.6526 17.9306 10.81 17.8029C10.8986 17.7309 10.9718 17.6426 11.0255 17.5428C11.0792 17.4431 11.1123 17.334 11.1228 17.2218C11.1334 17.1095 11.1213 16.9963 11.0871 16.8887C11.0529 16.781 10.9974 16.681 10.9238 16.5944L7.7475 12.8576H18.125C18.3571 12.8576 18.5796 12.7673 18.7437 12.6066C18.9078 12.4458 19 12.2278 19 12.0005C19 11.7732 18.9078 11.5552 18.7437 11.3945C18.5796 11.2338 18.3571 11.1435 18.125 11.1435Z"
                            fill="black"
                          />
                          <rect
                            x="0.5"
                            y="0.5"
                            width="23"
                            height="23"
                            rx="3.5"
                            stroke="black"
                          />
                        </svg>
                        <svg
                          class="hover-back-button"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect width="24" height="24" rx="4" fill="#8DC73F" />
                          <path
                            d="M18.125 11.1435H7.7475L10.9238 7.40666C11.0723 7.23163 11.1437 7.00599 11.1224 6.77935C11.1011 6.55272 10.9887 6.34368 10.81 6.1982C10.6313 6.05272 10.4009 5.98273 10.1696 6.00363C9.93819 6.02452 9.72477 6.13459 9.57625 6.30962L5.20125 11.452C5.17182 11.4929 5.14549 11.5359 5.1225 11.5806C5.1225 11.6234 5.1225 11.6491 5.06125 11.692C5.02159 11.7903 5.00082 11.8949 5 12.0005C5.00082 12.1062 5.02159 12.2108 5.06125 12.3091C5.06125 12.3519 5.06125 12.3776 5.1225 12.4205C5.14549 12.4652 5.17182 12.5082 5.20125 12.5491L9.57625 17.6915C9.65852 17.7882 9.76154 17.866 9.87799 17.9193C9.99444 17.9727 10.1215 18.0002 10.25 18C10.4544 18.0004 10.6526 17.9306 10.81 17.8029C10.8986 17.7309 10.9718 17.6426 11.0255 17.5428C11.0792 17.4431 11.1123 17.334 11.1228 17.2218C11.1334 17.1095 11.1213 16.9963 11.0871 16.8887C11.0529 16.781 10.9974 16.681 10.9238 16.5944L7.7475 12.8576H18.125C18.3571 12.8576 18.5796 12.7673 18.7437 12.6066C18.9078 12.4458 19 12.2278 19 12.0005C19 11.7732 18.9078 11.5552 18.7437 11.3945C18.5796 11.2338 18.3571 11.1435 18.125 11.1435Z"
                            fill="white"
                          />
                        </svg>
                      </button>
                      <p
                        class="text-sm text-center py-2 text-gray-dark"
                        v-if="sessions_group && sessions_group.length == 0"
                      >
                        No slots available or scheduled for this class
                      </p>

                      <div v-for="c in sessions_group" :key="c.id">
                        <div
                          class="flex justify-between py-2 my-3 rounded-lg"
                          style="background: #f4f4f4"
                        >
                          <div>
                            <p
                              class="align-baseline capitalize text-gray-350 pl-6 py-2"
                            >
                              {{ c.title }}
                            </p>
                          </div>
                          <div
                            class="text-gray-800 col-span-2 col-start-4 pr-2 w-2/5"
                          >
                            <p class="text-md text-gray-350">
                              {{ getFormattedDate(c.start_date, c.timezone, 'MMM DD, YYYY (ddd)') }}
                            </p>
                            <p class="text-xs text-gray-350">
                              {{ getFormattedDate(c.start_date, c.timezone, 'h:mm A') }} -
                              {{ getFormattedDate(c.end_date, c.timezone, 'h:mm A') }}
                            </p>
                          </div>
                        </div>
                      </div>

                      <div class="text-center">
                        <section>
                          <button
                            class="bg-green-light w-full text-base text-white mt-4 py-2 px-4 rounded-lg"
                            @click="handleJoinClick"
                            v-if="cost"
                          >
                            Complete Booking
                          </button>
                          <!-- :to="{
                              name: 'UserSessionLive',
                              params: { id: id },
                            }" -->
                          <button
                            type="button"
                            class="bg-green-light w-full text-base text-white mt-4 py-2 px-4 rounded-lg"
                            @click="onclickBookFreeClass"
                            v-else
                          >
                            Book
                          </button>
                          <!-- <button
                            class="uppercase bg-green-light w-72 text-base text-white mt-4 py-1 px-4 rounded"
                            v-if="
                              cost <= wallet_balance &&
                              cost > 0 &&
                              paymentEnableDisable
                            "
                            @click="handleJoinClick"
                          >
                            Pay
                          </button> -->
                        </section>
                        <!-- <div class="flex items-center justify-between py-2">
                          <p class="text-gray-darker text-xs">
                            You have ${{ wallet_balance }} left in your wallet
                          </p>
                          <button
                            type="button"
                            class="font-semibold text-gray-dark text-md"
                            @click.prevent="handleButtonClick"
                          >
                            + Add Money
                          </button>
                        </div> -->
                      </div>
                    </div>
                    <UserReportingModal
                      v-if="isUserReportingModalOpen"
                      :isUserReportingModalOpen="isUserReportingModalOpen"
                      :handleUserReportingModal="handleUserReportingModal"
                      :category_id="1"
                    />
                  </section>
                </section>
                <div
                  v-show="isSlotOpen"
                  v-if="!isCourseJoinModalOpen"
                  class="mb-8 fixed md:static left-0 bottom-0 bg-white w-full"
                >
                  <h5
                    class="uppercase mb-4 mt-8 text-gray-dark font-semibold text-xs"
                  >
                    Select slot for specific time and date
                  </h5>

                  <div
                    class="px-3 py-3 rounded-md bg-gray-50 ring-1 ring-gray-400"
                    style="background: #f4f4f4"
                  >
                    <div class="flex justify-between">
                      <button
                        v-if="
                          batches &&
                          batches.course_groups &&
                          batches.course_groups.available &&
                          batches.course_groups.available.data &&
                          batches.course_groups.available.data.length > 1
                        "
                        @click="handleFooterPopper(true, 'showMore')"
                        class="text-gray-dark font-medium text-sm flex md:hidden items-center"
                      >
                        show more
                      </button>
                    </div>

                    <div class="hidden md:inline">
                      <CourseGroupAvailables
                        v-on:sessions-group="handleJoinModal"
                        v-on:hide-courses="handleHideCourses"
                        v-on:show-courses="handleHideCourses"
                        @sessions-group="handleSessionsGroup"
                        :data="batches"
                        :course_groups="
                          batches &&
                          batches.course_groups &&
                          batches.course_groups.available &&
                          batches.course_groups.available.data
                        "
                      />
                    </div>

                    <div class="inline md:hidden">
                      <CourseGroupAvailables
                        v-on:sessions-group="handleJoinModal"
                        v-on:hide-courses="handleHideCourses"
                        v-on:show-courses="handleHideCourses"
                        :data="batches"
                        :course_groups="
                          batches &&
                          batches.course_groups &&
                          batches.course_groups.available &&
                          batches.course_groups.available.data.slice(0, 1)
                        "
                        type="slotOnMobileDevice"
                        :handleFooterPopper="handleFooterPopper"
                        :handleSelectSlotOnMobileDevice="
                          handleSelectSlotOnMobileDevice
                        "
                      />
                    </div>

                    <div v-show="isCoursesOpen">
                      <div
                        v-if="
                          batches &&
                          batches.course_groups &&
                          batches.course_groups.available.next_page_url
                        "
                        class="hidden md:inline"
                      >
                        <button
                          class="ring-gray-dark ring-1 rounded-lg py-2 w-full"
                          @click="
                            handleShowMoreAvail(
                              batches.course_groups.available.next_page_url
                            )
                          "
                        >
                          <span class="inline-flex">
                            Show more slots <ChevronDown class="w-4 mt-arrow" />
                          </span>
                        </button>
                      </div>

                      <div
                        v-if="
                          batches &&
                          batches.course_groups &&
                          !batches.course_groups.available.next_page_url &&
                          batches.course_groups.available.total > 3
                        "
                        class="hidden md:inline"
                      >
                        <button
                          class="ring-gray-800 ring-1 rounded-lg py-2 w-full"
                          @click="
                            handleShowLessAvail(
                              batches.course_groups.available.first_page_url
                            )
                          "
                        >
                          <span class="inline-flex">
                            Show less <ChevronUp class="w-5 mt-arrow ml-0.5" />
                          </span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <CoursePaymentModal
                  :value="isPaymentModal"
                  v-if="courseJoinData && course.details"
                  :details="course && course.details"
                  :batch="courseJoinData && courseJoinData.batch"
                  :handleClose="handleClose"
                  v-on:book-class="bookingSuceessHandler"
                >
                </CoursePaymentModal>
              </section>
            </section>
            <!-- <section class="flex-1 flex justify-center">
              <div class="mt-10">
                <div
                  v-if="message_requests && message_requests.status == 2"
                  class="rounded-lg bg-green-light text-white hover:bg-white hover:text-green-light hover:ring-green-light"
                >
                  <router-link
                    class="flex justify-between w-auto px-2 bg-green-light text-white hover:bg-white hover:text-green-light py-3 tracking-wide text-center text-sm ring-1 ring-gray-400 rounded-lg font-semibold"
                    :to="{ name: 'UserMessage' }"
                  >
                    <span class="pl-2">Contact Trainer</span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-5 w-6"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M13 7l5 5m0 0l-5 5m5-5H6"
                      />
                    </svg>
                  </router-link>
                </div>
                <div
                  v-else-if="
                    (message_requests && message_requests.status == 1) ||
                    (message_requests && message_requests.status == 3)
                  "
                >
                  <router-link
                    class="flex justify-between w-auto px-2 py-3 tracking-wide text-center text-sm ring-1 ring-gray-400 rounded-lg font-semibold"
                    :to="{ name: 'UserMessage' }"
                  >
                    <span class="pl-2">Request Pending</span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-5 w-6"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M13 7l5 5m0 0l-5 5m5-5H6"
                      />
                    </svg>
                  </router-link>
                </div>
                <div v-else>
                  <router-link
                    class="flex justify-between w-auto px-2 py-3 tracking-wide bg-green-light text-white hover:bg-white hover:text-green-light text-center text-sm ring-1 ring-gray-400 rounded-lg font-semibold"
                    :to="{
                      name: 'UserTrainerAbout',
                      params: {
                        trainer_id:
                          trainer && trainer.details && trainer.details.id,
                        isContactModalOpen: true,
                      },
                    }"
                  >
                    <span class="pl-2">Contact Trainer</span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-5 w-6"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M13 7l5 5m0 0l-5 5m5-5H6"
                      />
                    </svg>
                  </router-link>
                </div>
              </div>
            </section> -->
          </div>
        </section>
        <section class="md:flex" id="description">
          <section class="md:w-8/12 mb-32 md:mb-0">
            <div class="px-2">
              <section class="py-6 px-2">
                <h3 class="font-bold text-xl">Course Sessions</h3>
                <div class="py-4">
                  <div class="flex">
                    <div v-for="d in userCourseDetail.sessions" :key="d.id">
                      <div
                        class="max-w-xs overflow-hidden rounded-lg shadow-lg mr-4"
                      >
                        <img
                          class="object-cover w-full h-24"
                          :src="baseUrlSrc(d.thumbnail_url)"
                          alt=""
                          @error="defaultImage"
                        />
                        <div class="px-2 py-1">
                          <h4
                            class="mb-0 text-md font-semibold tracking-tight text-gray-800 capitalize"
                          >
                            {{ handleStr(d.title, 30) }}
                          </h4>
                          <p class="text-sm text-gray-700">
                            {{ minToHourMin(d.duration)[0] }}
                            <span class="text-gray-light text-xs">hr</span>
                            {{ minToHourMin(d.duration)[1] }}
                            <span class="text-gray-light text-xs">mins</span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
              <!-- course joined for mobile-->
              <!-- <section class="md:w-4/12 grid md:hidden">
                <div
                  v-if="
                    batches &&
                    batches.course_groups &&
                    batches.course_groups.joined &&
                    batches.course_groups.joined.length
                  "
                  class="p-4"
                >
                  <div
                    class="p-4 rounded-lg shadow-lg ring-1 ring-gray-400 bg-gray-50"
                  >
                    <div class="mb-2" v-if="batches.is_slots_subscribed">
                      <div class="flex justify-between items-center">
                        <h5 class="text-gray-dark font-semibold text-sm">
                          Your Class Pack
                        </h5>
                        <span class="text-xl"
                          >${{
                            batches &&
                            batches.course &&
                            batches.course.details &&
                            batches.course.details.cost
                          }}</span
                        >
                      </div>
                      <CourseGroupsJoined :data="batches" />
                    </div>
                  </div>
                </div>
              </section> -->
              <section
                class="py-6 px-2 border-gray-280 border-b-2"
                id="about-the-trainer"
              >
                <h3 class="text-gray-light text-2xl">Meet your trainer</h3>
                <div class="relative flex mt-4 items-center">
                  <Avatar
                    :classStr="'h-12 w-12'"
                    :src="
                      trainer &&
                      trainer.details &&
                      baseUrlSrc(trainer.details.thumbnail_url)
                    "
                  />
                  <div class="ml-2">
                    <div class="flex justify-between items-center">
                      <router-link
                        :to="{
                          name: 'UserTrainerAbout',
                          params: {
                            trainer_id:
                              trainer && trainer.details && trainer.details.id,
                          },
                        }"
                      >
                        <h5
                          class="text-xl text-gray-700 capitalize hover:underline"
                        >
                          {{
                            trainer && trainer.details && trainer.details.name
                          }}
                        </h5>
                      </router-link>
                    </div>
                    <div class="flex">
                      <Rating :data="trainer.average_rating" />
                      <span class="text-gray-800 text-xs"
                        >{{ trainer.average_rating }}({{
                          trainer.total_count
                        }})</span
                      >
                    </div>
                  </div>
                </div>
                <p class="text-gray-350 pt-8 pb-4 text-sm">
                  {{
                    showDescriptionModal
                      ? trainer &&
                        trainer.details &&
                        trainer.details.description
                      : handleStr(
                          trainer &&
                            trainer.details &&
                            trainer.details.description,
                          300
                        )
                  }}
                </p>
                <button
                  type="button"
                  class="text-green-light cursor-pointer focus:outline-none"
                  @click="showDescriptionModal = !showDescriptionModal"
                  v-if="
                    trainer &&
                    trainer.details &&
                    trainer.details.description.length > 150
                  "
                >
                  Read {{ showDescriptionModal ? "less" : "more" }}
                </button>
                <section id="reviews">
                  <h3 class="pt-4 text-gray-light text-2xl">Reviews</h3>
                </section>
              </section>
              <section
                class="py-6 px-2 border-gray-280"
                v-if="course_feedback && course_feedback.length"
              >
                <div class="flex justify-between items-center">
                  <h3 class="text-gray-light text-2xl">Class Feedback</h3>
                  <button
                    type="button"
                    class="inline-flex items-center h-8 px-1 text-sm transition-colors duration-150 ring-1 text-white rounded-md focus:outline-none bg-green-light hover:text-green-light hover:bg-white ring-green-light"
                    @click="toggleSessionReview"
                  >
                    See All
                  </button>
                </div>
                <div class="py-4 pt-0">
                  <SessionReviewList :data="course_feedback.slice(0, 4)" />
                </div>
                <div v-if="sessionFeedbackAll">
                  <SessionFeedbackAll
                    :data="course_feedback"
                    :sessionFeedbackAll="sessionFeedbackAll"
                    :handleSessionFeedbackAllModal="
                      handleSessionFeedbackAllModal
                    "
                  />
                </div>
              </section>
            </div>
          </section>
        </section>
        <section class="py-6 px-2 border-gray-280">
          <h3 class="text-gray-800 text-lg font-semibold">Recommended Class Packs</h3>
          <div class="py-4">
            <RecommendedSessionCardList
              :data="recommended"
              :isCourse="true"
            />
          </div>
        </section>
        <ConfirmationModal
          modalTitle="Booking Confirmation"
          modalQuestion="Are you sure you want to Book Free Class Pack ?"
          :isCancellable="true"
          modalConfirmText="Confirm"
          :confirmationModalOpen="bookingConfirmation"
          :modalCancelHandler="toggleBookingConfirmation"
          :confirmModalHandler="freeBookingConfirmationHandler"
        ></ConfirmationModal>
      </div>
    </section>
  </UserLayout>
</template>

<script>
import UserLayout from "@/components/layouts/UserLayout";
import { Avatar, Rating, ConfirmationModal } from "@/components/t-components";
import CoursePaymentModal from "@/components/t-components/CoursePaymentModal";
import CourseGroupsJoined from "@/components/CourseGroupsJoined";
import SessionJoinModal from "@/components/SessionJoinModal.vue";
import SessionReviewList from "@/components/SessionReviewList.vue";
import UserReportingModal from "@/components/UserReportingModal.vue";
import CourseGroupAvailables from "@/components/CourseGroupAvailables";
import SelectSlotFooterModal from "@/components/SelectSlotFooterModal";
import SessionFeedbackAll from "@/components/user/SessionFeedbackAll.vue";
import SessionDetailsThumbnail from "@/components/SessionDetailsThumbnail";
import RecommendedSessionCardList from "@/components/RecommendedSessionCardList";
import { DotsVertical, ChevronDown, ChevronUp } from "@/components/icons";
import ClickOutside from "vue-click-outside";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "CourseDetails",
  components: {
    UserLayout,
    SessionDetailsThumbnail,
    CourseGroupsJoined,
    CourseGroupAvailables,
    RecommendedSessionCardList,
    Avatar,
    DotsVertical,
    Rating,
    SelectSlotFooterModal,
    ChevronDown,
    ChevronUp,
    SessionReviewList,
    SessionJoinModal,
    UserReportingModal,
    SessionFeedbackAll,
    CoursePaymentModal,
    ConfirmationModal
  },
  data() {
    return {
      isPaymentModal: false,
      showDescriptionModal: false,
      isCoursesOpen: true,
      isSlotOpen: true,
      batches: {},
      recommended: {},
      course: {},
      trainer: {},
      sessions_group: [],
      isCourseJoinModalOpen: false,
      start_date: "",
      end_date: "",
      cost: null,
      is_private: "",
      course_id: "",
      group_id: "",
      id: "",
      wallet_balance: "",
      showPopper: false,
      sessionFeedbackAll: false,
      paymentSuccessRedirectProps: {},
      selectedCourseSlotId: null,
      course_feedback: [],
      message_requests: [],
      isUserReportingModalOpen: false,
      isDotsVerticalOpen: false,
      courseJoinData: {},
      bookingConfirmation: false,
      bookingInfo: null
    };
  },
  computed: {
    ...mapGetters(["userCourseDetail", "trainerDetail"]),
  },
  methods: {
    ...mapActions([
      "getUserCourseDetail",
      "getUserCourseDetailMore",
      "getUserCourseDetailLess",
      "userCourseJoin",
      "userAddMoney",
      "getTrainerDetail",
      "postUserBookFreeClass",
    ]),

    handleClose() {
      this.isPaymentModal = !this.isPaymentModal;
    },

    handleSessionsGroup(value) {
      this.sessions_group = value;
    },
    handleUserReportingModal(val) {
      this.isUserReportingModalOpen = val;
    },
    handleCourseJoinModal(val) {
      this.isCourseJoinModalOpen = val;
    },
    handleSessionFeedbackAllModal(val) {
      this.sessionFeedbackAll = val;
    },

    handleJoinModal(val) {
      if (this.getToken()) {
        this.showPopper = false;
        this.cost = val[0].cost;
        this.course_id = val[0].course_id;
        this.end_date = val[0].end_date;
        this.group_id = val[0].group_id;
        this.id = val[0].id;
        this.is_private = val[0].is_private;
        this.start_date = val[0].start_date;
        this.courseJoinData.batch = val;
        this.isCourseJoinModalOpen = !this.isCourseJoinModalOpen;

        this.paymentSuccessRedirectProps = {
          ...this.paymentSuccessRedirectProps,
          modalId: val[0].id,
        };
      } else {
        this.$router.push({
          name: "Login",
        });
      }
    },

    handleFooterPopper(value, type) {
      this.showPopper = value;
      if (type === "showMore") {
        this.selectedCourseSlotId = null;
      }
    },
    handleSelectSlotOnMobileDevice(id, showFooterPopper) {
      this.handleFooterPopper(showFooterPopper);
      this.selectedCourseSlotId = id;
    },

    async handleJoinClick() {
      const data = {
        batch_id: this.id,
        group_id: this.group_id,
        course_id: this.course_id,
        cost: this.cost,
        is_private: this.is_private,
      };
      // await this.userCourseJoin(data);
      // this.isCourseJoinModalOpen = !this.isCourseJoinModalOpen;
      this.handleClose()
    },

    async bookingSuceessHandler () {
      this.handleClose()
      this.toggleJoinInfoHandler()
      await this.getCourseBookingDetails()
    },
    toggleJoinInfoHandler () {
      this.isCourseJoinModalOpen = !this.isCourseJoinModalOpen
    },
    async getCourseBookingDetails () {
      await this.getUserCourseDetail(this.$route.params.id);
      this.batches = this.userCourseDetail;
    },
    async onclickBookFreeClass() {
      var batchIds =
        this.courseJoinData &&
        this.courseJoinData.batch.map((e) => e.id).join(", ");
        this.bookingInfo = {
        entityId: this.course_id,
        entityType: 2, // COURSE CONSTANT
        batchId: batchIds,
        paymentStatus: "free",
      };
      this.toggleBookingConfirmation()
      // setTimeout(() => window.location.reload(), 1000);
    },
    toggleBookingConfirmation () {
      this.bookingConfirmation = !this.bookingConfirmation
    },
    freeBookingConfirmationHandler () {
      this.toggleBookingConfirmation()
      this.postUserBookFreeClass(this.bookingInfo).then(() => {
        window.location.reload();
      })
    },

    handleButtonClick() {
      // this.userAddMoney();
      const paymentSuccessRedirectProps = {
        ...this.paymentSuccessRedirectProps,
        redirectUrl: this.$route.path,
        componentName: "sessionPurchase",
      };
      localStorage.setItem(
        "paymentSuccessRedirectProps",
        JSON.stringify(paymentSuccessRedirectProps)
      );
      this.$router.push({ name: "UserAddMoney" });
    },

    handleDate(val) {
      const name = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Nov",
        "Dec",
      ];
      const date = new Date(val);
      const str =
        name[date.getMonth()] +
        " " +
        ("0" + date.getDate()).slice(-2) +
        ", " +
        date.getFullYear();
      return str;
    },

    // handleTime(val) {
    //   return new Date(val).toLocaleString("en-US", {
    //     hour: "numeric",
    //     minute: "numeric",
    //     hour12: true,
    //   });
    // },

    handleShowMoreAvail(str) {
      const params = str.substring(str.indexOf("?"));
      this.getUserCourseDetailMore(this.$route.params.id + params);
    },
    handleShowLessAvail(str) {
      const params = str.substring(str.indexOf("?"));
      this.getUserCourseDetailLess(this.$route.params.id + params);
    },

    handleHideCourses() {
      this.isCoursesOpen = !this.isCoursesOpen;
    },

    handleHideSlot() {
      this.isSlotOpen = !this.isSlotOpen;
    },

    toggleDotsVertical() {
      this.isDotsVerticalOpen = false;
    },
    toggleSessionReview() {
      this.sessionFeedbackAll = true;
    },
  },
  directives: {
    ClickOutside,
  },
  async created() {
    await this.getCourseBookingDetails()
    this.recommended = this.userCourseDetail.recommended;
    this.course = this.userCourseDetail.course;
    this.trainer = this.userCourseDetail.trainer;
    this.wallet_balance = this.userCourseDetail.wallet_balance;
    this.course_feedback =
      this.userCourseDetail.reviews && this.userCourseDetail.reviews.data;
    const paymentSuccessRedirectProps = JSON.parse(
      localStorage.getItem("paymentSuccessRedirectProps")
    );
    if (paymentSuccessRedirectProps && paymentSuccessRedirectProps.modalId) {
      this.handleJoinModal(paymentSuccessRedirectProps.modalId);
    }
    localStorage.removeItem("paymentSuccessRedirectProps");
    await this.getTrainerDetail(this.trainer.details.id);
    this.message_requests = this.trainerDetail.message_requests;
    this.trainer_id = this.trainer.details.id;
  },
};
</script>

<style scoped>
.back-button > .standard-back-button {
  display: block;
}

.back-button > .hover-back-button {
  display: none;
}

.back-button:hover > .standard-back-button {
  display: none;
}

.back-button:hover > .hover-back-button {
  display: block;
}
</style>